export default __webpack_public_path__ + "static/media/DSC_0543.332fb198.jpg";